export { DadoGerenciavel } from './DadoGerenciavel'
